module.exports = __webpack_public_path__ + "img/descartaveisImage.2fd0997a.svg";